"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var SingleSelectionItem = function (_a) {
    var focus = _a.focus, index = _a.index, setFocus = _a.setFocus, option = _a.option, handleItemClick = _a.handleItemClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (focus) {
            ref.current.focus();
        }
    }, [focus]);
    var handleSelect = (0, react_1.useCallback)(function () {
        setFocus(index);
    }, [index, setFocus]);
    return ((0, jsx_runtime_1.jsx)("li", { tabIndex: focus ? 0 : -1, onKeyPress: handleSelect, ref: ref, role: "group" // role="group" is a must here for accessibility
        , children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Dropdown.Item, { eventKey: option.title, "aria-selected": option.selected, onClick: !disabled ? handleItemClick : undefined, role: "option", children: option.title }, "".concat(option.id, "-").concat(option.title)) }, option.id));
};
exports.default = SingleSelectionItem;
